import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../auth/services/auth.service';

@Component({
  selector: 'app-topbar',
  imports: [RouterLink],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent {
  private readonly authService = inject(AuthService);

  readonly pageTitle = input('Home');
  readonly pageSubtitle = input('DeKalb County Case Management');
  readonly menuClick = output<void>();

  readonly fullName = this.authService.fullName;
  readonly profileRoute = computed(() => {
    const userId = this.authService.user()?.id;
    return userId ? ['/users', userId, 'profile'] : ['/home'];
  });
  readonly roleLabel = computed(() => this.authService.role() ?? '');
  readonly initials = computed(() => {
    const user = this.authService.user();
    if (!user) return 'U';
    return `${user.firstName[0] ?? ''}${user.lastName[0] ?? ''}`.toUpperCase();
  });
}